export const userInputs = [
  {
    id: 'displayName',
    label: 'Name and surname',
    type: 'text',
    placeholder: 'John Doe',
  },
  // {
  //   id: 'firstName',
  //   label: 'First Name',
  //   type: 'text',
  //   placeholder: 'John Doe',
  //   isRequired: false,
  // },
  // {
  //   id: 'lastName',
  //   label: 'Last Name',
  //   type: 'text',
  //   placeholder: 'John Doe',
  //   isRequired: false,
  // },
  {
    id: 'dob',
    label: 'Date of Birth',
    type: 'date',
    placeholder: 'DD/MM/YYYY',
  },
  {
    id: 'gender',
    label: 'Gender',
    type: 'select',
    options: [
      { value: '', label: 'Select Gender' },
      { value: 'male', label: 'Male' },
      { value: 'female', label: 'Female' },
      { value: 'group', label: 'Group' },
    ],
  },
  {
    id: 'trust',
    label: 'Beneficiary (Type)',
    type: 'select',
    options: [
      { value: '', label: 'Select Beneficiary' },
      { value: 'individual', label: 'Individual' },
      { value: 'corporation', label: 'Corporation' },
    ],
  },
  // Corporation-specific fields should NOT be here
  {
    id: 'email',
    label: 'Email',
    type: 'mail',
    placeholder: 'john_doe@gmail.com',
  },
  {
    id: 'phone',
    label: 'Phone',
    type: 'text',
    placeholder: '+233 234 567 89',
  },
  {
    id: 'address',
    label: 'Address',
    type: 'text',
    placeholder: 'Golf. St. Accra',
  },
  {
    id: 'digital',
    label: 'Digital Address',
    type: 'text',
    placeholder: 'EH-000-0254',
  },
  {
    id: 'account',
    label: 'Account',
    type: 'text',
    placeholder: '2611000061234567',
    isRequired: false,
  },
  {
    id: 'attendance',
    label: 'AGM Attendance Year',
    type: 'select',
    options: [
      { value: '', label: 'Select AGM Year' },
      { value: '2024', label: '2024 AGM' },
      { value: '2025', label: '2025 AGM' },
      { value: '2026', label: '2026 AGM' },
      { value: '2027', label: '2027 AGM' },
      { value: '2028', label: '2028 AGM' },
      { value: '2029', label: '2029 AGM' },
      { value: '2030', label: '2030 AGM' },
      { value: '2031', label: '2031 AGM' },
      { value: '2032', label: '2032 AGM' },
      { value: '2033', label: '2033 AGM' },
      { value: '2034', label: '2034 AGM' },
      { value: '2035', label: '2035 AGM' },
      { value: '2036', label: '2036 AGM' },
      { value: '2037', label: '2037 AGM' },
      { value: '2038', label: '2038 AGM' },
      { value: '2039', label: '2039 AGM' },
      { value: '2040', label: '2040 AGM' },
      { value: '2041', label: '2041 AGM' },
      { value: '2042', label: '2042 AGM' },
      { value: '2043', label: '2043 AGM' },
      { value: '2044', label: '2044 AGM' },
      { value: '2045', label: '2045 AGM' },
      { value: '2046', label: '2046 AGM' },
      { value: '2047', label: '2047 AGM' },
      { value: '2048', label: '2048 AGM' },
      { value: '2049', label: '2049 AGM' },
      { value: '2050', label: '2050 AGM' },
      { value: '2051', label: '2051 AGM' },
      { value: '2052', label: '2052 AGM' },
      { value: '2053', label: '2053 AGM' },
      { value: '2054', label: '2054 AGM' },
      { value: '2055', label: '2055 AGM' },
      { value: '2056', label: '2056 AGM' },
      { value: '2057', label: '2057 AGM' },
      { value: '2058', label: '2058 AGM' },
      { value: '2059', label: '2059 AGM' },
      { value: '2060', label: '2060 AGM' },
    ],
  },
  {
    id: 'dop',
    label: 'Date of Purchase',
    type: 'date',
    placeholder: 'DD/MM/YYYY',
  },
  {
    id: 'cert',
    label: 'Certificate Number',
    type: 'text',
    placeholder: 'e.g 0000250',
    isRequired: false,
  },
  {
    id: 'channel',
    label: 'Channel of Dividend Payment',
    type: 'select',
    options: [
      { value: '', label: 'Select Payment Channel' },
      { value: 'cash', label: 'Cash' },
      { value: 'momo', label: 'MoMo' },
      { value: 'bank_transfer', label: 'Bank Transfer' },
      { value: 'draft', label: 'Draft' },
    ],
  },
  {
    id: 'code',
    label: 'Branch Code',
    type: 'select',
    options: [
      { value: '', label: 'Select a branch code' },
      { value: '116', label: 'Nkawkaw' },
      { value: '117', label: 'Praso' },
      { value: '111', label: 'Ejisu' },
      { value: '118', label: 'Anyinam' },
      { value: '114', label: 'Mpraeso' },
      { value: '112', label: 'Obo' },
      { value: '113', label: 'Tafo' },
      { value: '119', label: 'Konongo' },
    ],
  },
  {
    id: 'share',
    label: 'Number of Shares',
    type: 'text',
    placeholder: '100',
  },
  {
    id: 'price',
    label: 'Share Amount',
    type: 'text',
    placeholder: 'GH₵',
  },
  {
    id: 'card',
    label: 'Ghana Card',
    type: 'text',
    placeholder: 'GHA-000123456-7',
    isRequired: false,
  },
  {
    id: 'kin',
    label: 'Next of Kin',
    type: 'text',
    placeholder: 'John Doe',
  },
  {
    id: 'kin-contact',
    label: "Next of Kin's Contact",
    type: 'text',
    placeholder: '233 50254 1210',
  },

  {
    id: 'inputter',
    label: 'Name of Inputer',
    type: 'text',
    placeholder: 'John Doe',
  },
];
